export const environment = {
  agencyCode: "armsdata-dev",
  domain: "https://armsdata-dev.azurewebsites.net/",
  apiUrl:
    "https://app-armstracker-api-dev-002-f5aug9g0a0fda3ar.australiaeast-01.azurewebsites.net/",
  production: true,
};
